var r = /* @__PURE__ */ ((c) => (c.GRAPHICS_DOCUMENT = "graphics-document", c.GRAPHICS_OBJECT = "graphics-object", c.GRAPHICS_SYMBOL = "graphics-symbol", c.GROUP = "group", c.DOCUMENT = "document", c.CHECKBOX = "checkbox", c.BUTTON = "button", c.MENU = "menu", c.MENU_ITEM = "menuitem", c.IMG = "img", c))(r || {});
export {
  r as R
};
//# sourceMappingURL=a11y-7bad4f48.mjs.map
